import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconSliceLocation = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--slice-location")} iconColor={color} size={size} width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <mask id="mask0_4173_438" style={{ maskType: "alpha", }} maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="24">
  <rect x="0.5" width="24" height="24" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_4173_438)">
  <path d="M12.5 11.5C12.9218 11.5 13.2773 11.3555 13.5663 11.0664C13.8554 10.7773 14 10.4218 14 10C14 9.5782 13.8554 9.22275 13.5663 8.93365C13.2773 8.64455 12.9218 8.5 12.5 8.5C12.0782 8.5 11.7228 8.64455 11.4337 8.93365C11.1446 9.22275 11 9.5782 11 10C11 10.4218 11.1446 10.7773 11.4337 11.0664C11.7228 11.3555 12.0782 11.5 12.5 11.5ZM12.5 20.2539C14.5846 18.4385 16.1891 16.6208 17.3135 14.801C18.4378 12.9811 19 11.4474 19 10.2C19 8.22948 18.3728 6.62019 17.1183 5.37213C15.8638 4.12404 14.3244 3.5 12.5 3.5C10.6757 3.5 9.13623 4.12404 7.88173 5.37213C6.62724 6.62019 6 8.22948 6 10.2C6 11.4474 6.56218 12.9811 7.68655 14.801C8.8109 16.6208 10.4154 18.4385 12.5 20.2539ZM12.5 21.6154C9.97052 19.3705 8.08814 17.2881 6.85288 15.3683C5.61763 13.4484 5 11.7257 5 10.2C5 7.85385 5.75609 5.98397 7.26827 4.59037C8.78044 3.19679 10.5244 2.5 12.5 2.5C14.4756 2.5 16.2196 3.19679 17.7317 4.59037C19.2439 5.98397 20 7.85385 20 10.2C20 11.7257 19.3824 13.4484 18.1471 15.3683C16.9119 17.2881 15.0295 19.3705 12.5 21.6154Z" fill="#44190A"/>
  </g>
  </IconWrapper>
)
